(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["apx-policies"] && !Shopify.designMode) return;
  try {
    (function(){
  function initAcc(root){
    if(root.dataset.apxAccInit) return; root.dataset.apxAccInit='1';
    var triggers = root.querySelectorAll('[data-apx-acc-trigger]');
    triggers.forEach(function(btn){
      var panel = btn.parentElement.querySelector('[data-apx-acc-panel]');
      btn.addEventListener('click', function(){
        var isOpen = btn.getAttribute('aria-expanded')==='true';
        // close all (one open at a time)
        triggers.forEach(function(b){
          var p = b.parentElement.querySelector('[data-apx-acc-panel]');
          b.setAttribute('aria-expanded','false');
          p.style.height = '0px';
        });
        if(!isOpen){
          btn.setAttribute('aria-expanded','true');
          panel.style.height = panel.firstElementChild.offsetHeight + 'px';
        }
      });
    });
    // keep open panel sized correctly on resize
    window.addEventListener('resize', function(){
      root.querySelectorAll('[data-apx-acc-trigger][aria-expanded="true"]').forEach(function(b){
        var p = b.parentElement.querySelector('[data-apx-acc-panel]');
        p.style.height = p.firstElementChild.offsetHeight + 'px';
      });
    });
  }
  function run(){ document.querySelectorAll('[data-apx-acc]').forEach(initAcc); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
  } catch(e) { console.error(e); }
})();

})();
